export default __webpack_public_path__ + "static/media/Bonechill Talisman.4412cba4.jpg";